import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface DrywallProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Drywall: React.FC<DrywallProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [drywall, set_drywall] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Drywall'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Drywall': v } } })
    );
    const label = 'Drywall';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(drywall)}
                />
            ) : (
                <MoneyBox
                    id={'drywall'}
                    allowNegative={false}
                    value={drywall}
                    onChange={(value) => set_drywall(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
